<template>
  <!-- 藏品档案-藏品管理 -->
  <div class="page-public-list">
    <!-- 表头搜索 -->
    <cmpSearchDict ref="cmpSearchDict" :pageType="`6`" @getParams="getHeadParams"></cmpSearchDict>

    <div class="com-list-content" style="margin: 0">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="addCollect">
            <svg-icon icon-class="add" />&nbsp;新增藏品
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="tableRef" @sort-change="sortChange" stripe v-loading="listLoading" :data="tableData"
          :cell-class-name="(item)=>{ if(item.columnIndex==1) return 'g-column-light-box'}"
          :row-key="(row)=>{ return row.collectId}">
          <el-table-column v-for="(item,key) in titleData"
            :sortable="item.tableName == 'signCode' ||item.tableName ==  'typeCode' || item.tableName == 'collectLevel'"
            :key="key" :prop="item.tableName" :label="item.columnName"
            :min-width="item.tableName=='collectYear' || item.tableName=='collectName'?'20%':'10%'"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <viewer :options="{ url: 'data-maxUrl' }" v-if="scope.column.property==='thumbPicture'">
                <img class="g-pointer" :src="(scope.row.collectImages && scope.row.collectImages[0].attPath) || ''"
                  :data-maxUrl="scope.row.collectImages && scope.row.collectImages[0].attPath" alt :onerror="defaultImg"
                  style="width: 36px;">
              </viewer>

              <a class="m-btn" type="text" style="margin-left:0" @click="showDetail(scope.row.collectId)"
                v-else-if="scope.column.property==='collectName'">{{ scope.row.collectName }}</a>

              <span v-else-if="scope.column.property==='attachmentId'">
                <i class='el-icon-check' v-if="scope.row[scope.column.property]"></i>
                <i class='el-icon-minus' v-else></i>
              </span>

              <span v-else-if="scope.column.property==='threeDimensionalInfo'">
                <i class='el-icon-check' v-if="scope.row[scope.column.property]"></i>
                <i class='el-icon-minus' v-else></i>
              </span>
              <span v-else-if="scope.column.property==='operation'">
                <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
                <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
              </span>
              <span v-else>{{scope.row[scope.column.property]}}</span>

            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <dialog-name-detail ref="dialogNameDetail"></dialog-name-detail>

    <add-collect ref="addCollect" @refresh="initList"></add-collect>
  </div>
</template>

<script>
import cmpSearchDict from '@cmp/collect/search-dict'
import dialogNameDetail from '@views/collect2/record/dialog-name-detail'
import addCollect from './dialog-add-collect'

export default {
  components: { cmpSearchDict, dialogNameDetail, addCollect },
  data() {
    return {
      headParams: {
        collectTexture: '', // 质地类别
        collectDisablity: '', // 完残程度
        source: '', // 藏品来源
        qualityRange: '', // 质量范围
        enterCollectRange: '', // enterCollectRange
        collectType: '', // 藏品分类
        collectYear: '', // 藏品年代
        collectLevel: '', // 藏品级别
        isHigh: '', //是否高清图
      },
      order: '1',
      form: {},
      listQuery: {
        currentPage: 1,
        size: 10
      },
      filterTitle: ['thumbPicture', "collectName", "collectCode", "collectLevel", "collectType", "censusNumber", "collectYear"],
      total: 0,
      tableData: [], // 表格数据
      titleData: [{
        columnName: "藏品图片",
        tableName: "thumbPicture"
      }, {
        columnName: "藏品名称",
        tableName: "collectName"
      }, {
        columnName: "总登记号",
        tableName: "signCode"
      }, {
        columnName: "分类号",
        tableName: "typeCode"
      }, {
        columnName: "类别",
        tableName: "collectType"
      }, {
        columnName: "年代",
        tableName: "collectYear"
      }, {
        columnName: "级别",
        tableName: "collectLevel"
      }, {
        columnName: "高清图片",
        tableName: "attachmentId"
      }, {
        columnName: "三维模型",
        tableName: "threeDimensionalInfo"
      }, {
        columnName: "操作",
        tableName: "operation"
      }],
      listLoading: true,
      defaultImg: this.$store.state.app.defaultImg
    }
  },

  filters: {
    filterProperty(val) {
      if (val) {
        return "<i class='el-icon-check'></i>"
      } else {
        return "<i class='el-icon-check'></i>"
      }
    }
  },

  created() {
    // this.getTitleDataList()
    this.initList()
  },
  methods: {
    // 获取藏品公开字段
    getTitleDataList() {
      this.$http
        .get('/collection/getOpenColumnData', {})
        .then(res => {
          if (res.success) {
            let results = res.result
            results.map(item => {
              this.filterTitle.map(title => {
                if (title == item.tableName) {
                  this.titleData.push(item)
                }
              })
            })
            let addParam = [{
              columnName: "高清图片",
              tableName: "HDPicture"
            }, {
              columnName: "三维模型",
              tableName: "threeDimensional"
            }, {
              columnName: "操作",
              tableName: "operation"
            }]

            this.titleData = this.titleData.concat(addParam)
          }
        })
    },

    sortChange(column) {
      let order = ""
      if (column.prop == 'signCode') {
        if (column.order == 'ascending') {
          order = '1'
        } else if (column.order == 'descending') {
          order = '2'
        } else {
          order = ""
        }
      } else if (column.prop == 'typeCode') {
        if (column.order == 'ascending') {
          order = '3'
        } else if (column.order == 'descending') {
          order = '4'
        } else {
          order = ""
        }
      } else if (column.prop == 'collectLevel') {
        if (column.order == 'ascending') {
          order = '5'
        } else if (column.order == 'descending') {
          order = '6'
        } else {
          order = ""
        }
      }
      this.order = order
      this.listQuery.currentPage = 1
      this.initList()
    },
    // 初始化表格
    initList() {
      this.listLoading = true
      this.$http
        .get('/collection/list', {
          ...this.listQuery,
          order: this.order,
          ...this.headParams
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.tableData = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },

    addCollect() {
      this.$refs['addCollect'].init('add')
    },

    // 获取头部参数
    getHeadParams(params) {
      let f = 1
      for (let k in params) {
        if (params[k]) {
          f = 0
        }
      }
      // 重置排序
      if (f == 1) {
        this.$refs.tableRef.clearSort()
      }
      this.listQuery.currentPage = 1
      this.headParams = params
      this.initList()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },
    // 藏品名称
    showDetail(collectId) {
      this.$refs['addCollect'].init('detail', collectId)
    },

    handleEdit(obj) {
      this.$refs['addCollect'].init('edit', obj.collectId)
    },
    handleDelete(obj) {
      console.log(obj)
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$http
            .get('/collection/delete', { id: obj.collectId }).then(res => {
              if (res.success) {
                this.$message.success('删除成功')
                this.initList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.page-public-list {
  width: 0;
  flex: 1;
  .table {
    .eye-box {
      position: relative;
      display: inline-block;
      width: 100%;
      padding-right: 20px;
      .eye {
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 5px;
      }
    }
  }
}
</style>


